(() => {
  if (window.stCartInstalled) return;
  window.stCartInstalled = true;
  const root = window.Shopify?.routes?.root || '/';
  const config = JSON.parse(document.querySelector('[data-st-cart-config]')?.textContent || '{}');
  const t = key => config.strings?.[key] || key;
  const money = cents => new Intl.NumberFormat(config.locale || document.documentElement.lang, {style:'currency',currency:config.currency || window.Shopify?.currency?.active || 'NOK',minimumFractionDigits:0,maximumFractionDigits:2}).format(Number(cents) / 100);
  const escape = text => String(text ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const priceMarkup = (price, compareAt) => `<span>${escape(money(price))}</span>${Number(compareAt) > Number(price) ? ` <del class="st-cart-card-compare" style="margin-inline-start:6px;opacity:.55">${escape(money(compareAt))}</del>` : ''}`;
  let busy = false, modal = null, modalOpener = null, modalProduct = null, modalVariant = null, modalQuantity = 1, modalColors = [], modalRequest = 0;
  const productCache = new Map();
  const request = async (path, body) => {
    const response = await fetch(root + path, body ? {method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(body)} : {headers:{'Accept':'application/json'}});
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : t('updateError'));
    return data;
  };
  async function productOptions(handle) {
    if (!productCache.has(handle)) {
      const pending = fetch(root + 'products/' + encodeURIComponent(handle) + '?view=st-cart-options').then(async response => {
        if (!response.ok) throw new Error(t('quickAddUnavailable'));
        const data = await response.json();
        if (!data.id || !Array.isArray(data.variants)) throw new Error(t('quickAddUnavailable'));
        return data;
      }).catch(error => {productCache.delete(handle);throw error;});
      productCache.set(handle,pending);
    }
    return productCache.get(handle);
  }
  const sections = () => {
    const values=[];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections:values}}));
    document.querySelectorAll('[data-st-cart-page]').forEach(el=>values.push(el.dataset.section));
    return [...new Set(values)].slice(0,5);
  };
  const payload = data => ({...data,sections:sections(),sections_url:location.pathname});
  function feedback(text) {
    document.querySelectorAll('[data-st-cart-feedback], .st-cart-modal-status').forEach(el=>{el.textContent=text;el.hidden=!text;});
    if(text){const body=document.getElementById('cart-drawer')?.shadowRoot?.querySelector('[part=body]');if(body)body.scrollTop=0;}
  }
  function setBusy(value) {
    busy=value;
    document.querySelectorAll('[data-st-cart-surface], .st-cart-modal').forEach(el=>{
      el.setAttribute('aria-busy',String(value));
      el.querySelectorAll('button,input,select').forEach(control=>{
        if(value){if(control.dataset.stWasDisabled===undefined)control.dataset.stWasDisabled=String(control.disabled);control.disabled=true;}
        else if(control.dataset.stWasDisabled!==undefined){control.disabled=control.dataset.stWasDisabled==='true';delete control.dataset.stWasDisabled;}
      });
    });
  }
  async function render(cart, baseEvent='line-item:change') {
    if (!cart.sections || Object.values(cart.sections).some(html=>!html)) {
      const response=await fetch(root+'?sections='+encodeURIComponent(sections().join(',')));
      if(!response.ok) throw new Error(t('uncertain'));
      cart.sections=await response.json();
    }
    const refreshed = new Promise(resolve=>{
      const done=()=>{clearTimeout(timer);document.removeEventListener('cart-drawer:refreshed',done);resolve();};
      const timer=setTimeout(done,2500);
      document.addEventListener('cart-drawer:refreshed',done,{once:true});
    });
    document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent,cart,onSuccessDo:'force_open_drawer'}}));
    await refreshed;
    init();
  }
  document.addEventListener('cart:change',event=>{
    document.querySelectorAll('[data-st-cart-page]').forEach(page=>{
      const html=event.detail.cart.sections?.[page.dataset.section];
      if(!html)return;
      const next=new DOMParser().parseFromString(html,'text/html').querySelector('[data-st-cart-page]');
      if(next)page.replaceWith(next);
    });
    init();
  });
  async function mutate(task) {
    if(busy)return;
    setBusy(true);feedback('');
    try {await task();}
    catch(error){
      const message=error instanceof TypeError?t('uncertain'):error.message;
      try {await render(await request('cart.js'));} catch(_) {}
      feedback(message);
    } finally {setBusy(false);init();}
  }
  async function add(variant, quantity=1) {
    if(!variant?.available)throw new Error(t('unavailable'));
    const properties=Object.fromEntries(Object.entries(variant.properties || {}).filter(([,value])=>value!==''&&value!=null));
    const added=await request('cart/add.js',payload({items:[{id:variant.id,quantity,properties}]}));
    const cart=await request('cart.js');cart.sections=added.sections;
    document.documentElement.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:added.items,cart}}));
    closeModal(false);
    await render(cart,'variant:add');
  }
  const signature = properties => JSON.stringify(Object.entries(properties||{}).filter(([,v])=>v!=null&&v!=='').sort(([a],[b])=>a.localeCompare(b)));
  document.addEventListener('click',event=>{
    const toggle=event.target.closest('[data-st-size-toggle]');
    if(toggle){const panel=document.getElementById(toggle.getAttribute('aria-controls'));panel.hidden=!panel.hidden;toggle.setAttribute('aria-expanded',String(!panel.hidden));return;}
    const quick=event.target.closest('[data-st-quick]');
    if(quick){event.preventDefault();if(!busy)openModal(quick);return;}
    const quantity=event.target.closest('[data-st-cart-quantity]');
    if(quantity){event.preventDefault();const row=quantity.closest('[data-st-cart-line]');mutate(async()=>render(await request('cart/change.js',payload({id:row.dataset.key,quantity:Number(quantity.dataset.stCartQuantity)}))));return;}
    const size=event.target.closest('[data-st-cart-size]');
    if(size){
      event.preventDefault();const row=size.closest('[data-st-cart-line]'),id=Number(size.dataset.stCartSize);
      if(id===Number(row.dataset.variant))return;
      mutate(async()=>{
        const before=await request('cart.js'),old=before.items.find(item=>item.key===row.dataset.key);
        const allowed=row.dataset.stPropertyKeys.split('|');
        if(!old || old.selling_plan_allocation || old.parent_relationship || old.has_components || Object.keys(old.properties||{}).some(key=>!allowed.includes(key)))throw new Error(t('uncertain'));
        // Keep the shopper's pillowcase size; update only the size-dependent pillowcase count.
        const properties={...(old.properties||{})};
        if(size.dataset.count)properties[size.dataset.countKey]=size.dataset.count;
        else delete properties[size.dataset.countKey];
        const matchesOld=item=>item.variant_id===old.variant_id&&!item.selling_plan_allocation&&signature(item.properties)===signature(old.properties);
        if(before.items.filter(matchesOld).length!==1)throw new Error(t('uncertain'));
        // Add first so a stock rejection cannot remove the shopper's current item.
        await request('cart/add.js',{items:[{id,quantity:old.quantity,properties}]});
        try {
          const after=await request('cart.js'),previous=after.items.filter(matchesOld);
          if(previous.length!==1||previous[0].quantity!==old.quantity)throw new Error(t('partialSwap'));
          await render(await request('cart/change.js',payload({id:previous[0].key,quantity:0})));
        } catch(error){throw new Error(t('partialSwap'));}
      });return;
    }
    const remove=event.target.closest('[data-st-remove-discount]');
    if(remove)mutate(async()=>{
      const cart=await request('cart.js');const codes=(cart.discount_codes||[]).filter(x=>x.code.toLowerCase()!==remove.dataset.stRemoveDiscount.toLowerCase()).map(x=>x.code);
      await render(await request('cart/update.js',payload({discount:codes.join(',')})));
    });
  });
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(form.matches('[data-st-cart-add]')){
      event.preventDefault();const id=Number(form.elements.id.value);
      mutate(async()=>{const product=await productOptions(form.dataset.handle);await add(product.variants.find(variant=>variant.id===id));});
    }else if(form.matches('[data-st-cart-discount]')){
      event.preventDefault();const code=form.elements.discount.value.trim();if(!code)return;
      mutate(async()=>{
        const before=await request('cart.js');const codes=(before.discount_codes||[]).filter(x=>x.applicable).map(x=>x.code);
        let cart=await request('cart/update.js',payload({discount:[...new Set([...codes,code])].join(',')}));
        const accepted=(cart.discount_codes||[]).some(x=>x.applicable&&x.code.toLowerCase()===code.toLowerCase());
        if(!accepted)cart=await request('cart/update.js',payload({discount:codes.join(',')}));
        await render(cart);
        if(!accepted)feedback(t('discountError'));
      });
    }else if(busy&&form.closest('[data-st-cart-surface]')) event.preventDefault();
  });
  function closeModal(restore=true) {
    if(!modal)return;
    modalRequest++;
    modal.close();modal.remove();modal=null;
    const drawer=document.getElementById('cart-drawer');
    if(drawer?.hasAttribute('open'))drawer.focusTrap?.unpause();
    if(restore&&modalOpener?.isConnected)modalOpener.focus();
  }
  async function openModal(opener) {
    closeModal(false);modalOpener=opener;modalQuantity=1;modalColors=[];
    modal=document.createElement('dialog');modal.className='st-cart-modal';modal.setAttribute('aria-labelledby','st-cart-modal-title');
    modal.innerHTML=`<button type="button" class="st-cart-modal-close" aria-label="${escape(t('quickAddClose'))}">×</button><img class="st-cart-modal-image" alt=""><div class="st-cart-modal-info"><h2 id="st-cart-modal-title"></h2><p class="st-cart-modal-price"></p><div class="st-cart-modal-controls"></div><p class="st-cart-modal-status" role="status"></p><a class="st-cart-modal-details">${escape(t('quickAddDetails'))}</a></div>`;
    document.body.append(modal);
    document.getElementById('cart-drawer')?.focusTrap?.pause();
    modal.showModal();
    modal.querySelector('.st-cart-modal-close').onclick=()=>{if(!busy)closeModal();};
    modal.addEventListener('cancel',event=>{event.preventDefault();if(!busy)closeModal();});
    modal.addEventListener('click',event=>{if(event.target===modal){const r=modal.getBoundingClientRect();if((event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)&&!busy)closeModal();}});
    const card=opener.closest('.st-cart-card');
    modal.querySelector('h2').textContent=card.querySelector('h4').textContent;
    modal.querySelector('img').src=card.querySelector('img')?.src||'';
    modal.querySelector('.st-cart-modal-price').innerHTML=card.querySelector('[data-st-card-price]').innerHTML;
    await loadModalColor(opener.dataset.stQuick);
  }
  // Capture Escape before the drawer's own focus trap can close the bag too.
  document.addEventListener('keydown',event=>{if(modal&&event.key==='Escape'){event.preventDefault();event.stopImmediatePropagation();if(!busy)closeModal();}},true);
  async function loadModalColor(handle) {
    const token=++modalRequest;
    modal.querySelector('.st-cart-modal-controls').replaceChildren();
    modal.querySelector('.st-cart-modal-status').textContent=t('quickAddLoading');
    modal.querySelector('.st-cart-modal-status').hidden=false;
    modal.querySelector('.st-cart-modal-details').href=root+'products/'+encodeURIComponent(handle);
    try {
      const product=await productOptions(handle);
      if(!modal||token!==modalRequest)return;
      modalProduct=product;const normalizeSize = value => String(value || '').toLowerCase().replace(/\s|cm/g, '').replace(/×/g, 'x').replace(/^2x\|/, '');
      const preferred = normalizeSize(modalOpener?.dataset.preferredSize);
      modalVariant=product.variants.find(v=>v.available && preferred && normalizeSize(v.options[0])===preferred)||product.variants.find(v=>v.available)||product.variants[0];
      if(!modalColors.length){
        modalColors=[{handle:product.handle,title:product.title,name:product.color,hex:product.hex,image:product.image},...product.colors];
        modalColors=modalColors.filter((color,i,all)=>all.findIndex(c=>c.handle===color.handle)===i);
      }
      renderModal();
    }catch(_){if(modal&&token===modalRequest)modal.querySelector('.st-cart-modal-status').textContent=t('quickAddUnavailable');}
  }
  function renderModal() {
    if(!modal)return;
    const p=modalProduct,v=modalVariant;
    modal.querySelector('h2').textContent=p.title;
    const img=modal.querySelector('img');img.hidden=!p.image;if(p.image)img.src=p.image;img.alt=p.title;
    modal.querySelector('.st-cart-modal-price').innerHTML=v?priceMarkup(v.price,v.compare_at_price):'';
    const status=modal.querySelector('.st-cart-modal-status');status.textContent=v?.available?'':t('unavailable');status.hidden=!!v?.available;
    modal.querySelector('.st-cart-modal-details').href=p.url+(v?'?variant='+v.id:'');
    let html='';
    if(modalColors.length>1)html+=`<div class="st-cart-modal-options"><p>${escape(t('quickAddColor'))}: <span>${escape(p.color||p.title)}</span></p><div class="st-cart-modal-colors">${modalColors.map(color=>`<button type="button" data-color="${escape(color.handle)}" aria-label="${escape(color.name||color.title)}" aria-pressed="${color.handle===p.handle}" style="${/^#[0-9a-f]{3,8}$/i.test(color.hex)?'background-color:'+color.hex:color.image?'background-image:url(&quot;'+escape(color.image)+'&quot;)':''}"></button>`).join('')}</div></div>`;
    if(v) p.options.forEach((name,index)=>{
      const values=[...new Set(p.variants.map(variant=>variant.options[index]))];
      if(values.length<=1)return;
      html+=`<div class="st-cart-modal-options"><p>${escape(name)}: ${escape(v.options[index])}</p><div class="st-cart-modal-choices">${values.map(value=>{
        const candidates=p.variants.filter(candidate=>candidate.options[index]===value);
        const exact=candidates.find(candidate=>candidate.options.every((option,i)=>i===index||option===v.options[i]));
        const choice=exact||candidates.find(candidate=>candidate.available)||candidates[0];
        return `<button type="button" data-variant="${choice.id}" aria-pressed="${v.options[index]===value}" ${choice.available?'':'disabled'}>${escape(value)}${choice.available?'':' — '+escape(t('unavailable'))}</button>`;
      }).join('')}</div></div>`;
    });
    if(v)html+=`<div class="st-cart-modal-quantity"><span>${escape(t('quickAddQuantity'))}</span><div class="st-cart-quantity"><button type="button" data-modal-quantity="-1" aria-label="${escape(t('decreaseQuantity'))}" ${modalQuantity<=1?'disabled':''}>−</button><span aria-live="polite">${modalQuantity}</span><button type="button" data-modal-quantity="1" aria-label="${escape(t('increaseQuantity'))}">+</button></div></div><button type="button" class="st-cart-checkout" data-modal-add ${v.available?'':'disabled'}>${escape(t('quickAddSubmit'))}</button>`;
    const controls=modal.querySelector('.st-cart-modal-controls');controls.innerHTML=html;
    controls.querySelectorAll('[data-color]').forEach(button=>button.onclick=()=>loadModalColor(button.dataset.color));
    controls.querySelectorAll('[data-variant]').forEach(button=>button.onclick=()=>{modalVariant=p.variants.find(variant=>variant.id===Number(button.dataset.variant));renderModal();modal.querySelector(`[data-variant="${button.dataset.variant}"]`)?.focus();});
    controls.querySelectorAll('[data-modal-quantity]').forEach(button=>button.onclick=()=>{modalQuantity=Math.max(1,modalQuantity+Number(button.dataset.modalQuantity));renderModal();modal.querySelector(`[data-modal-quantity="${button.dataset.modalQuantity}"]`)?.focus();});
    controls.querySelector('[data-modal-add]')?.addEventListener('click',()=>mutate(()=>add(modalVariant,modalQuantity)));
  }
  function init() {
    document.querySelectorAll('[data-st-money]').forEach(el=>el.textContent=money(el.dataset.stMoney));
    document.querySelectorAll('[data-st-cart-add]').forEach(form=>{
      const update=()=>{const option=form.elements.id.selectedOptions[0];form.closest('.st-cart-card').querySelector('[data-st-card-price]').innerHTML=option?priceMarkup(option.dataset.price,option.dataset.compareAtPrice):'';form.querySelector('button[type=submit]').disabled=busy||option?.dataset.available!=='true';};
      if(!form.dataset.ready){form.dataset.ready='true';form.elements.id.addEventListener('change',update);}update();
    });
    document.querySelectorAll('.st-cart-rail').forEach(rail=>{
      if(rail.dataset.cartReady)return;rail.dataset.cartReady='true';
      const track=rail.querySelector('.st-cart-track'),bar=rail.querySelector('.st-cart-scroll-progress span');
      const update=()=>{bar.style.transform=`scaleX(${Math.min(1,(track.clientWidth+track.scrollLeft)/track.scrollWidth)})`;};
      track.addEventListener('scroll',update,{passive:true});const observer=new ResizeObserver(()=>{if(!track.isConnected)observer.disconnect();else update();});observer.observe(track);update();
    });
    document.querySelectorAll('[data-st-recommendations]').forEach(async container=>{
      if(container.dataset.loaded||!container.dataset.seed)return;container.dataset.loaded='true';
      const intent=container.dataset.stRecommendations;
      try {
        const params=new URLSearchParams({section_id:intent==='related'?'st-cart-related':'st-cart-upsells',product_id:container.dataset.seed,intent,limit:'10'});
        const response=await fetch(root+'recommendations/products?'+params);
        if(!response.ok||!container.isConnected)return;
        const html=await response.text();
        if(!container.isConnected)return;
        const rail=new DOMParser().parseFromString(html,'text/html').querySelector('.st-cart-rail');
        if(rail?.querySelector('.st-cart-card')){container.replaceChildren(rail);init();}
      }catch(_){/* The market-specific Sanity fallback remains available. */}
    });
    if(busy)setBusy(true);
  }
  document.addEventListener('cart-drawer:refreshed',init);
  document.addEventListener('shopify:section:load',init);
  init();
})();
